import { cn } from "@/lib/cn";

// Per-kit stock indicator. Thresholds:
//   > 200  → green "In stock"
//   1–200  → amber "Low stock"
//   0      → red "Out of stock"
export function StockBadge({ qty, className }: { qty: number; className?: string }) {
  const tone =
    qty === 0
      ? "bg-[#FBEAE9] text-[#B31217]"
      : qty <= 200
        ? "bg-[#FBEFD8] text-[#6B4200]"
        : "bg-[#E3F2EA] text-[color:var(--ok)]";

  const label =
    qty === 0
      ? "Out of stock"
      : `${qty <= 200 ? "Low stock" : "In stock"}: ${qty.toLocaleString("en-GB")}`;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-2xs font-semibold tracking-tight",
        tone,
        className,
      )}
    >
      <span className="h-1 w-1 rounded-full bg-current" aria-hidden />
      {label}
    </span>
  );
}
